import { Component } from '@angular/core';

@Component({
  selector: 'app-sem-permissao-page',
  templateUrl: './sem-permissao-page.component.html'
})
export class SemPermissaoPageComponent {
  irParaContexto(): void {
    // Reaproveita o fluxo global do AppComponent para abrir a modal de contexto.
    window.dispatchEvent(new Event('abrirModalContexto'));
  }
}

